<script>
import HelpExpansionPanelContent from './help-expansion-panel-content.vue'

export default {
  name: 'HelpPrimaryGroupPanel',
  components: { HelpExpansionPanelContent },
  props: {
    clientList: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    accordion: [],
  }),
}
</script>

<template>
  <v-expansion-panels v-model="accordion" accordion flat multiple hover>
    <v-expansion-panel
      v-for="client in clientList"
      :key="client.clientId"
      class="transparent"
    >
      <v-expansion-panel-header class="py-1">
        {{ client.clientName }}
      </v-expansion-panel-header>

      <v-expansion-panel-content class="py-1">
        <HelpExpansionPanelContent
          :client-id="client.clientId"
          :client-name="client.clientName"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
